module.exports = __webpack_public_path__ + "img/icon_sec2_04.d074d3eb.png";